<div
	class="bp-card builder-cover-bg"
	[style.background-color]="data.bg_color"
	[style.background-image]="data.hide_bg_image || !data.bg_thumbnail ? '' : ('url(' + data.bg_thumbnail.url + ')')"
>
	<div
		class="bp-card builder-default-layout"
		[style.max-width]="desktopWidth + 'px'"
	>
		<app-card-desktop [data]="data" class="d-none d-md-block"></app-card-desktop>
		<app-card-mobile [data]="data" class="d-md-none d-sm-flex"></app-card-mobile>
	</div>
</div>